// src/utils/songApi.js
import axios from './axios';

// Get all songs
export const getSongs = async () => {
  const response = await axios.get('/songs', {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  });
  return response.data;
};

// Create a new song with file uploads (cover + audio)
export const createSong = async (formData) => {
  const response = await axios.post('/songs', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update an existing song
export const updateSong = async (id, formData) => {
  const response = await axios.put(`/songs/${id}`, formData);
  return response.data;
};

// Delete a song
export const deleteSong = async (id) => {
  const response = await axios.delete(`/songs/${id}`);
  return response.data;
};
